import { useContext } from 'react';
import { AuthContext } from '../../auth/useAuthContext';
import { isFlagEnabled } from '../../utils/featureFlags';

export const useIsFlagEnabled = (flag: string) => {
  const { state } = useContext(AuthContext);

  return isFlagEnabled(state?.flags, flag);
};
